(function () {
    "use strict";

    angular.module('app').directive('fodbzCheckbox', CheckboxDirective);

    CheckboxDirective.$inject = [];
    function CheckboxDirective() {
        return {
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                fodbzModel: '=',
                fodbzFieldConst: '@',
                fodbzResource: '@'
            },
            template: `
                <div class="checkbox-inline" style="width:100%">
                    <label for="{{fodbzFieldConst}}" class="control-label" style="font-weight: normal;"> 
                        <input ng-model="fodbzModel"
                               type="checkbox"
                               id="{{fodbzFieldConst}}" 
                               name="{{fodbzFieldConst}}"> 
                            {{fodbzResource}} 
                    </label>
                </div>
            `,
        };
    }
})();
